import React, { useEffect, useMemo, useRef, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { FaChevronDown } from 'react-icons/fa6';
import './MultiSelect.scss';
import { MultiSelectProps, MultiSelectOption } from '../../types';

const MultiSelect = ({
  label,
  placeholder = 'Select options',
  options,
  value = [],
  onChange,
  labelStyle,
}: MultiSelectProps) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const close = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const selected = useMemo(() => options.filter((o) => value.includes(o.value)), [value, options]);

  const toggle = (opt: MultiSelectOption) => {
    onChange(value.includes(opt.value) ? value.filter((v) => v !== opt.value) : [...value, opt.value]);
  };

  const remove = (opt: MultiSelectOption, e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(value.filter((v) => v !== opt.value));
  };

  return (
    <div className="ms-root" ref={ref}>
      {label && (
        <div className="ms-label" style={labelStyle}>
          {label}
        </div>
      )}

      <div className="ms-trigger" onClick={() => setOpen(!open)}>
        <div className="ms-chips">
          {selected.length === 0 && <div className="ms-placeholder">{placeholder}</div>}
          {selected.map((opt) => (
            <div key={opt.value} className="ms-chip">
              {opt.label}
              <IoMdClose size={10} onClick={(e) => remove(opt, e)} />
            </div>
          ))}
        </div>
        <FaChevronDown size={12} color="#64748b" />
      </div>

      {open && (
        <ul className="ms-menu">
          {options.map((opt) => {
            const isActive = value.includes(opt.value);
            return (
              <li key={opt.value} className={isActive ? 'ms-item active' : 'ms-item'} onClick={() => toggle(opt)}>
                {opt.label}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default MultiSelect;
